import iconBR from './BR.png'

const Nav = (props) => {
    const bairros = []
    const locais = []
    const categorias = []

    props.roles.map((item) => {if(item.categoria != null && categorias.filter(elemento => elemento == item.categoria)[0] == undefined){categorias.push(item.categoria)}})
    props.eventosFiltrado.map((item) => {if(item.bairro != null && bairros.filter(elemento => elemento == item.bairro)[0] == undefined){bairros.push(item.bairro)}})
    props.eventosFiltrado.map((item) => {if(locais.filter(elemento => elemento == item.local)[0] == undefined){locais.push(item.local)}})

    return(
        <div className="fixed flex items-center bg-purple-50 w-screen z-50 text-xl h-16 justify-between border-b-2 px-4 md:px-5 lg:px-20 md:text-base">
            <div className="flex-shrink-0">
                <img src={iconBR} className="w-10 h-10 rounded-3xl" />
            </div>

            <div className="flex flex-row gap-2 overflow-x-auto scrollbar-hide max-w-[80vw] md:max-w-none">
                {categorias.sort().map((item) => (
                    <button key={item} className={`py-1 px-3 rounded-xl ${props.categoria == item ? 'bg-purple-950' : 'bg-blue-700'} text-slate-50 font-semibold whitespace-nowrap transition`} onClick={(e)=>{
                        const divRolagem = document.getElementById('conteudo')
                        if(divRolagem){divRolagem.scrollTo({ top: 0, behavior: 'smooth' })}
                        e.currentTarget.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest'})
                        props.setCategoria(item)
                        props.setsubcategoria(false)
                    }}>{item}</button>
                ))}
          </div>
        </div>
    )
}

export default Nav